import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as vibeLimitationsActions from '../actions/vibe-limitations.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {BuilderV2Service} from "../../builder-v2/builder-v2.service";

@Injectable()
export class VibeLimitationsEffects {

  constructor(
    private _actions$: Actions,
    private _builderV2Service: BuilderV2Service
  ) {
  }

    loadVibeLimitations$ = createEffect(() => this._actions$.pipe(
        ofType(vibeLimitationsActions.LOAD_VIBE_LIMITATIONS),
        mergeMap(() => {
            return this._builderV2Service.getVibeCodingLimitations()
                .pipe(
                    filter((response: DbResponse) => !!response),
                    map((response: DbResponse) => {
                        if (response.success && response.data) {
                            return new vibeLimitationsActions.LoadVibeLimitationsSuccess(response.data);
                        }
                        return new vibeLimitationsActions.LoadVibeLimitationsFail(response.message);
                    })
                );
        })
    ));
}
